import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { Subject } from 'rxjs';
//import { SessionStorageService } from 'angular-web-storage';
import { SvApiReturnType } from '../_model/SvApiReturnType';


@Injectable({
  providedIn: 'root'
})
export class HomeService {
  logout!: string;

  public setupchange = new Subject();
  public messageAndCode = new Subject();
  i18n: any;
  private loadSpinner = new BehaviorSubject(false);
  landingLoad = this.loadSpinner.asObservable();
  searchData = new Subject();
  searchAssignData = new Subject();
  searchDeptData = new Subject();
  searchInstData = new Subject();
  treeConfig = new Subject();
  public currentHTTPIntegrationModule!: object;
  public currentRemoteTicketIDField!: object;
  searchRegData = new Subject();
  public treeConfigurationData!: Object[];
  public subSetupChange = new Subject();
  setupDeptchange = new Subject();
  setupInstchange = new Subject();
  deletelogintoken!: string;
  userField!: any;
  sendMessage(message: boolean) {
    this.loadSpinner.next(message);
  }

  constructor(private http: HttpClient,
    @Inject(DOCUMENT) private document: Document,
  ) {

    // this.logout = sessionStorage.getItem('token');

  }

  kbObjectDelete(articleId: string): Observable<any> {
    const options = {
      body: {
        fileKey: articleId
      }
    };
    return this.http.delete(environment.kbapi_vi + 'kb/assets/objectdelete', options);
  }

  loadi18() {
    return this.http.get(environment.kbapi_vi + environment.i18n);

  }
  uploadFile(inst_id: any, data: any): Observable<HttpEvent<any>> {
    const url = environment.kbapi_vi + inst_id + '/' + 'file/upload';
    const req = new HttpRequest('POST', url, data, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }
  saveImage(data: any): Observable<any> {
    return this.http.post<any>(environment.kbapi_vi + 'kb/upload-image', data)
  }
  tokendelete(logout: any) {
    return this.http.delete(environment.kbapi_vi);
  }
  forcelogout(delete_token: any) {
    return this.http.delete(environment.kbapi_vi);

  }
  getInstitutionRegistryByKey(inst_id: Number, key: string): Observable<SvApiReturnType<any>> {
    return this.http.get<SvApiReturnType<any>>(environment.kbapi_vi + inst_id + '/getInstitutionRegistryByKey?key=' + key);
  }

  fetchi18n(channel: string, component: string, local: string): Observable<SvApiReturnType<Object>> {
    return this.http.get<SvApiReturnType<Object>>(environment.kbapi_vi + `i18n?channel=${channel}&component=${component}&local=${local}`);
  }

}


